import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Arma, backendOrigin } from "@/lib/armaApi";

const defaultBranding = {
  serverName: "BOYS OPS",
  tagline: "ARMA REFORGER COMMAND",
  logoUrl: null,
  backgroundUrl: null,
};

const InstanceContext = createContext({
  instance: "BOYS_V3",
  instances: ["BOYS_V3"],
  setInstance: () => {},
  mapInfo: null,
  health: null,
  branding: defaultBranding,
  refreshBranding: () => {},
});

export function InstanceProvider({ children }) {
  const [instance, setInstance] = useState(() =>
    localStorage.getItem("arma.instance") || "BOYS_V3"
  );
  const [instances, setInstances] = useState(["BOYS_V3"]);
  const [mapInfo, setMapInfo] = useState(null);
  const [health, setHealth] = useState(null);
  const [branding, setBranding] = useState(defaultBranding);

  useEffect(() => {
    localStorage.setItem("arma.instance", instance);
  }, [instance]);

  const refreshBranding = useCallback(() => {
    Arma.branding()
      .then((b) => {
        setBranding({
          serverName: b.serverName || defaultBranding.serverName,
          tagline: b.tagline || defaultBranding.tagline,
          logoUrl: b.logoUrl ? `${backendOrigin()}${b.logoUrl}` : null,
          backgroundUrl: b.backgroundUrl ? `${backendOrigin()}${b.backgroundUrl}` : null,
        });
      })
      .catch(() => setBranding(defaultBranding));
  }, []);

  useEffect(() => {
    Arma.health().then(setHealth).catch(() => setHealth({ status: "down", db: "unreachable" }));
    Arma.instances()
      .then((d) => {
        if (d.instances?.length) {
          setInstances(d.instances);
          if (!d.instances.includes(instance)) setInstance(d.instances[0]);
        }
      })
      .catch(() => {});
    refreshBranding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Karte pro Instanz laden und jede Minute pruefen (Missionswechsel ohne Reload).
  // Nur bei echter Aenderung setzen, sonst springt der Kartenausschnitt zurueck.
  useEffect(() => {
    let cancelled = false;
    const load = () =>
      Arma.currentMap(instance)
        .then((m) => {
          if (cancelled) return;
          setMapInfo((prev) =>
            prev &&
            prev.mapName === m.mapName &&
            prev.imageUrl === m.imageUrl &&
            JSON.stringify(prev.bounds) === JSON.stringify(m.bounds)
              ? prev
              : m
          );
        })
        .catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [instance]);

  return (
    <InstanceContext.Provider
      value={{ instance, instances, setInstance, mapInfo, health, branding, refreshBranding }}
    >
      {children}
    </InstanceContext.Provider>
  );
}

export const useInstance = () => useContext(InstanceContext);
